import React, { useEffect, useState } from 'react';
import ReviewsHeader from '../ReviewsHeader';
import SentimentTable from '../SentimentTable';
import JustifiedData from '../JustifiedData';
import OriginalPost from '../OriginalPost';
import CardCommon from '@/pages/opinion/components/CardCommon';
import './index.scss';
import { useIntl } from 'umi';

const Reviews = ({
  data,
  loading,
  userInfo,
  gameInfo,
  language,
  empty,
  isShowSentiment,
  wholeGameInfo,
  feedsSource,
  setTableLoading
}: any) => {
  const { formatMessage } = useIntl();
  return (
    <CardCommon
      loading={loading}
      loadingHeight={240}
      empty={empty}
      className="dbo-feeds-reviews-card"
      cardHeaderElement={
        <div className="dbo-feeds-reviews-deader">
          {formatMessage({ id: 'Reviews' })}
        </div>
      }
    >
      <>
        <ReviewsHeader
          data={data}
          gameInfo={gameInfo}
          language={language}
          isShowSentiment={isShowSentiment}
        />
        <JustifiedData data={data} language={language} />
        {data?.tweets_reply > 0 ? (
          <SentimentTable
            data={data}
            gameInfo={gameInfo}
            userInfo={userInfo}
            language={language}
            wholeGameInfo={wholeGameInfo}
            maxHeight={750}
            setTableLoading={setTableLoading}
          />
        ) : data?.comment_parent_id !== '-1' ? (
          <OriginalPost
            language={language}
            id={data?.comment_parent_id}
            commentTime={data?.comment_time}
            gameInfo={gameInfo}
            isShowSentiment={isShowSentiment}
            data={data}
            feedsSource={feedsSource}
            userInfo={userInfo}
          />
        ) : null}
      </>
    </CardCommon>
  );
};

export default Reviews;
